module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row form"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_make"
    }
  }, [_vm._v("Make")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.make),
      expression: "tractor.make"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Make",
      "id": "addAsset_make",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.make)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor, "make", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_model"
    }
  }, [_vm._v("Model")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.model),
      expression: "tractor.model"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Model",
      "id": "addAsset_model",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor, "model", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_ID"
    }
  }, [_vm._v("Asset ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.assetId),
      expression: "tractor.assetId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_ID",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.assetId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor, "assetId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_tractortype"
    }
  }, [_vm._v("Tractor Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.tractorType),
      expression: "tractor.tractorType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_tractortype",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tractor, "tractorType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "TractorOnly"
    }
  }, [_vm._v("Tractor Only")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "StraightTruck",
      "selected": ""
    }
  }, [_vm._v("Straight Truck")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_engine"
    }
  }, [_vm._v("Engine Type")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.engineType),
      expression: "tractor.engineType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Engine Type",
      "id": "addAsset_engine",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.engineType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor, "engineType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_emissions"
    }
  }, [_vm._v("Emissions Profile")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.emissionsProfile),
      expression: "tractor.emissionsProfile"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0'),
      expression: "'required|min_value:0'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "Emissions Profile",
      "id": "addAsset_emissions",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.emissionsProfile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor, "emissionsProfile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon su-group-addon"
  }, [_vm._v("g CO2 per ton-mile")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_telematics"
    }
  }, [_vm._v("Telematics ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.telematicsId),
      expression: "tractor.telematicsId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_telematics",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.telematicsId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor, "telematicsId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_GIAI"
    }
  }, [_vm._v("GIAI")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.giai),
      expression: "tractor.giai"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_GIAI",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.giai)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor, "giai", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.isStraightTruck) ? _c('div', [_c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title mb-3"
  }, [_vm._v("Straight Truck Details")]), _vm._v(" "), _c('div', {
    staticClass: "row form"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techprovider"
    }
  }, [_vm._v("Tech Provider")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.st.techProvider),
      expression: "tractor.st.techProvider"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_techprovider",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tractor.st, "techProvider", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dummyTracker"
    }
  }, [_vm._v("Dummy Tracker")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bluerover"
    }
  }, [_vm._v("BlueRover")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Tech Provider ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.st.techProviderId),
      expression: "tractor.st.techProviderId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.st.techProviderId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor.st, "techProviderId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_trailertype"
    }
  }, [_vm._v("Trailer Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.st.trailerType),
      expression: "tractor.st.trailerType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_trailertype",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tractor.st, "trailerType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DryVan"
    }
  }, [_vm._v("Dry Van")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Flatbed"
    }
  }, [_vm._v("Flatbed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ContainerChassis"
    }
  }, [_vm._v("Container Chassis")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_length"
    }
  }, [_vm._v("Length")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.st.length),
      expression: "tractor.st.length"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Length",
      "id": "addAsset_length",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.st.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor.st, "length", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_liftgate"
    }
  }, [_vm._v("Lift Gate")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.st.liftGate),
      expression: "tractor.st.liftGate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_liftgate",
      "name": "Lift Gate",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tractor.st, "liftGate", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "No"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_suspension"
    }
  }, [_vm._v("Suspension Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.st.suspension),
      expression: "tractor.st.suspension"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_suspension",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tractor.st, "suspension", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Spring"
    }
  }, [_vm._v("Spring")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Air"
    }
  }, [_vm._v("Air")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_refrigeration"
    }
  }, [_vm._v("Refrigeration Unit")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.st.refrigerationUnit),
      expression: "tractor.st.refrigerationUnit"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_refrigeration",
      "name": "Refrigeration Unit",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tractor.st, "refrigerationUnit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "No"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "card bg-white mb-3"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Refrigeration Unit Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Make")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.ru.make),
      expression: "tractor.ru.make"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "refrigeration unit's Make",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": !_vm.hasRefrigerationUnit || _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.ru.make)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor.ru, "make", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Model")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.ru.model),
      expression: "tractor.ru.model"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "refrigeration unit's Model",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": !_vm.hasRefrigerationUnit || _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.ru.model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor.ru, "model", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Engine Type")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.ru.engineType),
      expression: "tractor.ru.engineType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "refrigeration unit's Engine Type",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": !_vm.hasRefrigerationUnit || _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.ru.engineType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor.ru, "engineType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Emissions Profile")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tractor.ru.emissionsProfile),
      expression: "tractor.ru.emissionsProfile"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0'),
      expression: "'required|min_value:0'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "refrigeration unit's Emissions Profile",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": !_vm.hasRefrigerationUnit || _vm.readonly
    },
    domProps: {
      "value": (_vm.tractor.ru.emissionsProfile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tractor.ru, "emissionsProfile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon su-group-addon"
  }, [_vm._v("g CO2 per ton-mile")])])])])])])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2007672b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/asset/TractorForm.vue
// module id = 684
// module chunks = 0